import { render, staticRenderFns } from "./CommonOrderForAdm.vue?vue&type=template&id=709cb2a5&scoped=true&"
import script from "./CommonOrderForAdm.vue?vue&type=script&lang=js&"
export * from "./CommonOrderForAdm.vue?vue&type=script&lang=js&"
import style0 from "./CommonOrderForAdm.vue?vue&type=style&index=0&id=709cb2a5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709cb2a5",
  null
  
)

export default component.exports